module.exports = __webpack_public_path__ + "static/media/headline.5295335b.svg";